/**
 * Auth Layout
 * Layout for authentication pages (login, signup, etc.)
 */

import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '@schoolidb/store';

export function AuthLayout() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());

  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 to-primary-100 dark:from-gray-900 dark:to-gray-800 p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-primary-600">School iDB</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            Find your perfect school
          </p>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
